import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";
import { CONTACT } from "@/data/products";
import { RestoreLogo } from "@/components/RestoreMark";

export default function Footer() {
  return (
    <footer className="bg-sage-800 text-sand-100 mt-20 pb-24 lg:pb-16" data-testid="site-footer">
      <div className="container-x pt-16 lg:pt-24 grid gap-12 lg:grid-cols-4">
        <div className="lg:col-span-2 max-w-md">
          <RestoreLogo className="h-32 w-auto" data-testid="footer-logo" />
          <p className="mt-6 text-sand-100/70 leading-relaxed">
            Personalized wellness designed to help you feel your best — from IV therapy and consultations to targeted supplements and ongoing care.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" className="w-9 h-9 rounded-full border border-sand-100/25 grid place-items-center hover:bg-sand-100/10" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-sand-100/25 grid place-items-center hover:bg-sand-100/10" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <div className="overline text-clay-400">Visit</div>
          <div className="mt-4 space-y-3 text-sm text-sand-100/80">
            <div className="flex gap-2"><MapPin className="w-4 h-4 shrink-0 mt-0.5" /><span>{CONTACT.address}</span></div>
            <div className="flex gap-2"><Clock className="w-4 h-4 shrink-0 mt-0.5" /><span>{CONTACT.hours}</span></div>
            <a href={`tel:${CONTACT.phone}`} className="flex gap-2 hover:text-white"><Phone className="w-4 h-4 shrink-0 mt-0.5" /><span>{CONTACT.phone}</span></a>
            <a href={`mailto:${CONTACT.email}`} className="flex gap-2 hover:text-white"><Mail className="w-4 h-4 shrink-0 mt-0.5" /><span>{CONTACT.email}</span></a>
          </div>
        </div>

        <div>
          <div className="overline text-clay-400">Explore</div>
          <ul className="mt-4 space-y-2.5 text-sm text-sand-100/80">
            {[["/services","Services"],["/iv-therapy","IV Therapy"],["/memberships","Memberships"],["/shop","Shop"],["/guide","Restore Guide"],["/faq","FAQ"],["/contact","Contact"]].map(([to, label])=>(
              <li key={to}><Link to={to} className="hover:text-white">{label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="container-x mt-14 pt-6 border-t border-sand-100/10 flex flex-wrap gap-x-6 gap-y-2 items-center justify-between text-xs text-sand-100/50">
        <div>© {new Date().getFullYear()} Restore Wellness. All rights reserved.</div>
        <div className="flex items-center gap-2 text-sand-100/70" data-testid="veteran-badge">
          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full border border-clay-400/60 text-clay-400 text-[9px] font-semibold tracking-wider">★</span>
          Veteran Owned &amp; Operated
        </div>
        <div>Educational content only — not medical advice.</div>
      </div>
      <div className="container-x mt-4 pt-4 border-t border-sand-100/5 text-center text-[11px] text-sand-100/40" data-testid="agency-credit">
        Site crafted by{" "}
        <a
          href="https://smartmediasolutions.io"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sand-100/70 hover:text-white underline underline-offset-4 decoration-clay-400/40 hover:decoration-clay-400 transition-colors"
          data-testid="sms-link"
        >
          Smart Media Solutions
        </a>
      </div>
    </footer>
  );
}
